
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","fill":"currentColor","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.183 9.01c-1.104-2.215.01-4.658 2.131-5.931a2.306 2.306 0 013.046.613l1.562 2.131a3 3 0 01.264 3.116l-.41.82a.822.822 0 00-.015.747c.22.43.691 1.191 1.598 2.098.907.907 1.668 1.377 2.098 1.598.236.122.51.103.747-.016l.82-.41a3 3 0 013.116.265l2.13 1.562a2.306 2.306 0 01.614 3.046c-1.273 2.121-3.716 3.235-5.93 2.131-1.867-.93-4.251-2.469-6.777-4.994-2.525-2.526-4.064-4.91-4.994-6.777z"}})])
          )
        }
      }
    